module.exports = __webpack_public_path__ + "static/bicicle-2294eba576afe53404283b81f2c38a61.jpg";